import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { mobile, minTablet } from "utils/styles";
import backArrow from "assets/back-arrow.svg";
import closeIcon from "assets/akap/close-icon.svg";

const Container = styled.div`
  display: flex;
  align-items: center;
  background-color: #2560fa;
  padding: 16px 20px;
  position: relative;
  width: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  ${mobile`
    padding: 12px 16px;
  `}

  ${minTablet`
    padding: 20px 24px;
  `}
`;

const BackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  img {
    width: 30px;
    height: 30px;
    filter: brightness(0) invert(1);
  }
`;

const CloseIcon = styled.img`
  width: 30px;
  height: 30px;
  filter: brightness(0) invert(1);
`;

const BackIcon = styled.img`
  width: 30px;
  height: 30px;
  filter: brightness(0) invert(1);
`;

const RightButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: right;
  justify-content: right;
  border-radius: 50%;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  img {
    width: 30px;
    height: 30px;
    filter: brightness(0) invert(1);
  }
`;
const DownloadIcon = styled.img`
  width: 30px;
  height: 30px;
  filter: brightness(0) invert(1);
`;

const Title = styled.h1`
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  margin: 0;
  text-align: center;
  flex: 1;
  letter-spacing: 0.5px;

  ${mobile`
    font-size: 16px;
  `}

  ${minTablet`
    font-size: 20px;
  `}
`;

const Spacer = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${mobile`
    width: 36px;
    height: 36px;
  `}
`;

export const DetailsHeader = ({ title, onBack, className, isCloseButton, topRight }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };


  return (
    <Container className={className}>
      <BackButton onClick={handleBack}>
        {isCloseButton ? <CloseIcon src={closeIcon} alt="close" /> : <BackIcon src={backArrow} alt="Back" />}
      </BackButton>
      <Title>{title}</Title>
      {topRight ? (topRight) : (<Spacer />)}
    </Container>
  );
};
